import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CashCloseTable from "../../../../../components/utils/modalTable/cashCloseTable";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { Print } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const OtCashClose = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [supplier, setSupplier] = useState([]);
  const navigate = useNavigate()
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const roleId = localStorage.getItem("role_id")
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
    const [companyData , setCompanyData] = useState([])
    const [dateLimit, setDateLimit] = useState({
    fromDate :  moment().startOf('month').format(),
    toDate :  moment().format()
  })
  const[cust, setCust] = useState(null)
  const fixedOutlet = { id: outletId, fullname: outletName };
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.closing_expences_lines)
    setRowData(e.row)
    setOpen(true)
  }
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "salesManCode",
    headerName: "Salesman Code",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field:"salesManName",
    headerName: "Salesman Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "otCode",
    headerName: "Outlet Code",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Outlet Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_card",
    headerName: " Card",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_cash",
    headerName: " Cash",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_upi",
    headerName: " UPI",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_invoices",
    headerName: " Invoices",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_loyalty",
    headerName: " Loyalty",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  }, {
    field: "total_return",
    headerName: " Return",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  }, {
    field: "total_return_count",
    headerName: " Return Count",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  }, {
    field: "total_return_used",
    headerName: " Return Used",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  }, {
    field: "total_sales",
    headerName: " Sales",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  }, 
 
  {
    field: "avg_bills",
    headerName: "Avg Bills",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },{
    field: "amount_be_deposited",
    headerName: "Amount Be Deposited",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "next_day_balance",
    headerName: "Next Day Balance",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_discount_amount",
    headerName: "Disc Amt",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "tot",
    headerName: "Total",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableExport: true ,
    renderCell: (params) => {
      return (
        <div>
           <IconButton size="small" onClick={() => onEdit(params)}>
              <VisibilityIcon />
            </IconButton>
            <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton>
        </div>
       

      );
    },
  },
]

//   useEffect(() => {
// axios.get(`/v1/outlet/info/1`)
// .then((res) => {console.log(res.data); _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val));setCompanyData(res.data);})
// .catch((err) => {console.log(err)})
//   },[])
function handleThermal(e){
  console.log('Working!',e)
  console.log(e)
  const textData = {
    tot:e.tot,
    date:e.documentDate,
    totalSales:e.total_sales,
    cashSales:e.total_cash,
    cardSales:e.total_card,
    upiSales:e.total_upi,
    totalNoOfInvoice:e.total_invoices,
    totalSalesReturnAmount:e.total_return,
    SRamountUser:e.total_return_used,
    totalNoOfSalesReturn:e.total_return_count,
    averageofBills:e.avg_bills,
    netSales:e.total_sales,
    employee:e.salesManName
  }
  const tableData = _.map(e.closing_expences_lines, ((val , idx)=>({ 
    sno:++idx,
   denomination:val.denomination,
   count:val.count,
   total:val.total
  })))
  console.log(tableData)
  console.log(textData)
  // axios.post(`/v1/outlet_sales_master/getall`,{docno : e.billNo})
  // .then(res=>{
  //   const TotalData = {
  //     sub_total : Number(e.sub_total),
  //     gst: e.gst_Amt,
  //     totalAmount : Number(e.tot),
  //     roundOff : e.roff,
  //     returnAmnt: res.data.return_amount
  //   }
  dispatch(setThermalData({
    tableData : tableData,
    TotalData : textData,
    companyInfo:cust
  }))      
  dispatch(onPressButton())
  const name = `CashBill`
  navigate(`/cashClose/${name}`)  
  // })
  // .catch(err=>{
  //   console.log(err)
  //   dispatch(
  //     setSnackbar(true, "error", err.response.data.errors[0].message)
  //   );
  // })
  
      }
const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.date).format("DD-MM-YYYY"),
  salesManCode : val.sales_man_code,
  salesManName:val.sales_man_name,
  otCode:val.code,
  party : val.fullname,
  total_card:Math.round(val.total_card).toFixed(0),
  total_cash:Math.round(val.total_cash).toFixed(0),
  total_invoices:Math.round(val.total_invoices).toFixed(0),
  total_loyalty:Math.round(val.total_loyalty).toFixed(0),
  total_return:Math.round(val.total_return).toFixed(0),
  total_return_count:Math.round(val.total_return_count).toFixed(0),
  total_return_used:val.total_return_used,
  total_sales:Math.round(val.total_sales).toFixed(0),
  total_upi:Math.round(val.total_upi).toFixed(0),
  avg_bills:Math.round(val.avg_bills).toFixed(0),
  amount_be_deposited:Math.round(val.amount_be_deposited).toFixed(0),
  next_day_balance:Math.round(val.next_day_balance).toFixed(0),
  total_discount_amount:Math.round(val.total_discount_amount).toFixed(0),
  tot: parseFloat(val.total).toFixed(0),
  closing_expences_lines:val.closing_cash_lines,

  documentDate:moment(val.date).format("DD-MM-YYYY"),
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      // total += parseFloat(val.total);
      total += parseFloat(val.total_cash);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
const tableHeadData = [
  { id:1, label: "S No" },
  { id:2, label: "Date" },
  { id:3 , label:"denomination"},
  { id:4, label:"count"},
  { id:5 , label:"total"},
];
const tableBodyData = _.map(salesLines, (val,idx) => ({
  id:idx,
  sNo:idx+1,
  count:val.count,
  denomination:val.denomination,
  date:moment(val.created_at).format("DD-MM-YYYY"),
  total:parseFloat(val.total).toFixed(0),
}))
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleSalesReturn(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ? cust.id : fixedOutlet.id
  }
  axios.post('/v1/reports/closing/cash', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    // dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesReturn()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust])
  console.log(roleId != 2 )
  console.log(cust)
  return (
    <Fragment>
      <Helmet><title>Cash Close Reports</title></Helmet>
      <Typography variant="h6">Cash Close Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              // disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              // disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <CashCloseTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
    </Fragment>
  );
};

export default memo(OtCashClose);
